import script from "./PhotoEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhotoEditor.vue?vue&type=script&setup=true&lang=ts"

import "./PhotoEditor.vue?vue&type=style&index=0&id=5603ca38&lang=css"

const __exports__ = script;

export default __exports__